import React from 'react'
import Icons from '../../../../Icons'
import {_L, useLocaleState} from '../../../../../context/LocaleContext'
import styled from 'styled-components'

const VisitorCard = ({visitor, onClick}) => {
  const localeState = useLocaleState()

  const onItemClick = () => onClick({visitor})

  const {name, emId, emTitle, isVisitor, isNew} = visitor
  let emName = name || emId

  return isNew ? (
    <NewVisitorContainer onClick={onItemClick}>
      <Icons icon="ADD_ATTENDEE" width={28} height={28} />
      <NewVisitorText>{_L({key: 'New visitor', localeState})}</NewVisitorText>
    </NewVisitorContainer>
  ) : (
    <StyledCard onClick={onItemClick}>
      <CardTextContainer>
        <CardTitle>{emName}</CardTitle>
        <CardSubTitle>{emTitle}</CardSubTitle>
      </CardTextContainer>
      {isVisitor === '1' && (
        <VisitorContainer>
          <VisitorText>{_L({key: 'VISITOR', localeState})}</VisitorText>
        </VisitorContainer>
      )}
    </StyledCard>
  )
}

export default VisitorCard

const StyledCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  margin: 6px;
  width: 300px;
  height: 86px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);

  @media (max-width: 420px) {
    width: 100%;
    height: 60px;
  }
`

const CardTextContainer = styled.div`
  width: 75%;
  text-align: left;
  padding-left: 20px;

  @media (max-width: 420px) {
    padding-left: 8px;
  }
`

const StyledText = styled.div`
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.3px;

  @media (max-width: 420px) {
    font-size: 12px;
  }
`

const CardTitle = styled(StyledText)`
  color: #000000;
`

const CardSubTitle = styled(StyledText)`
  font-size: 14px;
  font-weight: normal;
  color: #a4a9b7;
`

const VisitorText = styled(StyledText)`
  font-size: 9px;
`

const NewVisitorText = styled(StyledText)`
  color: #ffffff;
  padding-left: 16px;
`
const VisitorContainer = styled.div`
  background-color: #bee1ff;
  padding: 4px;
  border-radius: 51px;
  color: #0070d0;
  margin-right: 10px;
`

const NewVisitorContainer = styled(StyledCard)`
  justify-content: center;
  background-color: #3395fe;
`
